/**
 * Costanti per il calcolo del Ravvedimento Operoso e Rateizzazione
 * Riferimento: D.Lgs. 472/1997 e successive modifiche
 */

import {
  TASSI_LEGALI,
  INTERESSE_RATEAZIONE_MENSILE,
  CODICI_TRIBUTO,
} from "../config/fiscalConstants";

// Data di entrata in vigore della riforma sanzioni (D.Lgs. 87/2024).
// Le violazioni con scadenza >= a questa data usano il set POST-riforma
// (sanzione base 25%); quelle precedenti il set PRE-riforma (sanzione base 30%).
export const DATA_RIFORMA_SANZIONI = "2024-09-01";

// Fasce sanzione ravvedimento operoso — PRE riforma (sanzione base 30%)
// Riferimento: D.Lgs. 472/1997 art. 13, per violazioni con scadenza < 01/09/2024
export const FASCE_SANZIONE_PRE_RIFORMA = [
  { minGiorni: 1, maxGiorni: 14, tipo: "giornaliero", percentuale: 0.000833, descrizione: "Ravvedimento sprint (1/10 di 1/15 del 30% al giorno)" },
  { minGiorni: 15, maxGiorni: 30, tipo: "fisso", percentuale: 0.015, descrizione: "Ravvedimento breve (1/10 del 15%)" },
  { minGiorni: 31, maxGiorni: 90, tipo: "fisso", percentuale: 0.0167, descrizione: "Ravvedimento intermedio (1/9 del 15%)" },
  { minGiorni: 91, maxGiorni: 365, tipo: "fisso", percentuale: 0.0375, descrizione: "Ravvedimento lungo (1/8 del 30%)" },
  { minGiorni: 366, maxGiorni: 730, tipo: "fisso", percentuale: 0.0429, descrizione: "Ravvedimento biennale (1/7 del 30%)" },
  { minGiorni: 731, maxGiorni: Infinity, tipo: "fisso", percentuale: 0.05, descrizione: "Ravvedimento lunghissimo (1/6 del 30%)" },
];

// Fasce sanzione ravvedimento operoso — POST riforma (sanzione base 25%)
// Riferimento: D.Lgs. 87/2024, per violazioni con scadenza >= 01/09/2024
export const FASCE_SANZIONE_POST_RIFORMA = [
  { minGiorni: 1, maxGiorni: 14, tipo: "giornaliero", percentuale: 0.000694, descrizione: "Ravvedimento sprint (1/10 di 1/15 del 25% al giorno)" },
  { minGiorni: 15, maxGiorni: 30, tipo: "fisso", percentuale: 0.0125, descrizione: "Ravvedimento breve (1/10 del 12,5%)" },
  { minGiorni: 31, maxGiorni: 90, tipo: "fisso", percentuale: 0.0139, descrizione: "Ravvedimento intermedio (1/9 del 12,5%)" },
  { minGiorni: 91, maxGiorni: 365, tipo: "fisso", percentuale: 0.03125, descrizione: "Ravvedimento lungo (1/8 del 25%)" },
  { minGiorni: 366, maxGiorni: 730, tipo: "fisso", percentuale: 0.0357, descrizione: "Ravvedimento biennale (1/7 del 25%)" },
  { minGiorni: 731, maxGiorni: Infinity, tipo: "fisso", percentuale: 0.0417, descrizione: "Ravvedimento lunghissimo (1/6 del 25%)" },
];

// Alias retrocompatibile: storicamente esisteva solo il set PRE-riforma.
// @deprecated usare getFasceSanzione(dataScadenza) per selezionare il set corretto.
export const FASCE_SANZIONE = FASCE_SANZIONE_PRE_RIFORMA;

// Tassi interesse legale e codici tributo: centralizzati in fiscalConstants
// (fonte di verità unica) e ri-esportati qui per retrocompatibilità.
export { TASSI_LEGALI, CODICI_TRIBUTO };

// Maggiorazione per rateizzazione saldo giugno (art. 20 D.Lgs. 241/1997).
// Alias retrocompatibile: coincide con l'interesse rateazione mensile (0,33%).
export const MAGGIORAZIONE_RATA = INTERESSE_RATEAZIONE_MENSILE;

// Numero massimo di rate per il saldo di giugno
export const MAX_RATE_GIUGNO = 6;

// Scadenze rate (dal saldo di giugno)
export const SCADENZE_RATE = [
  { numero: 1, data: "30/06", descrizione: "Prima rata / Unica soluzione" },
  { numero: 2, data: "16/07", descrizione: "Seconda rata" },
  { numero: 3, data: "20/08", descrizione: "Terza rata" },
  { numero: 4, data: "16/09", descrizione: "Quarta rata" },
  { numero: 5, data: "16/10", descrizione: "Quinta rata" },
  { numero: 6, data: "16/11", descrizione: "Sesta rata" },
];
